export const cssClasses = {
  root: 'form-group',
  input: 'autocomplete_search-input',
}

export const defaultBounds = new window.google.maps.LatLngBounds(
  new window.google.maps.LatLng(40.493, -74.26),
  new window.google.maps.LatLng(40.9155, -73.7)
)

export const options = {
  bounds: defaultBounds,
}



// WEBPACK FOOTER //
// ./src/components/PlacesAutoComplete/InputOptions.js